import { API, graphqlOperation } from "aws-amplify";
import { listChatDataSortBySortIndex, getChatData } from "graphql/queries";
import {
  ChatData,
  GetChatDataQuery,
  ListChatDataSortBySortIndexQuery,
  ModelSortDirection,
} from "types/graphqlapi";

export const listChatDataByInterviewId = async (interviewId: string) => {
  const list = [];
  let nextToken;
  do {
    const result = (await API.graphql(
      graphqlOperation(listChatDataSortBySortIndex, {
        interview_id: interviewId,
        sortDirection: ModelSortDirection.ASC,
        limit: 100,
        nextToken,
      })
    )) as {
      data: ListChatDataSortBySortIndexQuery;
    };

    const resultData = result?.data?.listChatDataSortBySortIndex
      ?.items as ChatData[];
    if (resultData.length > 0) {
      list.push(...resultData);
    }
    nextToken = result?.data?.listChatDataSortBySortIndex?.nextToken;
  } while (nextToken);

  return list;
};

export const getChatDataQuery = async (id: string) => {
  const result = (await API.graphql(
    graphqlOperation(getChatData, {
      id,
    })
  )) as {
    data: GetChatDataQuery;
  };

  return result.data.getChatData;
};
